import type {VoidFunctionComponent} from "react";
import React, {useEffect} from "react";
import s from "./MusicHomeSearchControl.module.scss";
import {SearchInput} from "../../../../../components/common/search-controls/search-input/SearchInput";
import {MusicHomeSearchControlResetButton} from "./ResetButton/MusicHomeSearchControlResetButton";
import {useMusicHomeSearchControlLogic} from "./MusicHomeSearchControl.logic";

export const MusicHomeSearchControl: VoidFunctionComponent = () => {
  const searchClassNames = [
    s.searchControls,
  ];

  const {isMobileSearchActive, handleSearchInputChange, handleSearchInputBlur, handleSearchInputFocus, searchValue, searchInputRef} = useMusicHomeSearchControlLogic();

  if (isMobileSearchActive) {
    searchClassNames.push(s.isActiveOnMobile)
  }
  useEffect(() => {
    if (!isMobileSearchActive){
      // nothing to do, return to exit
      return;
    }
    searchInputRef.current.focus();
  }, [searchInputRef, isMobileSearchActive])

  return (
    <div className={searchClassNames.join(` `)}>
      <SearchInput
        ref={searchInputRef}
        searchPlaceholder={`Search`}
        onFocusHandler={handleSearchInputFocus}
        onBlurHandler={handleSearchInputBlur}
        onChangeHandler={handleSearchInputChange}
        searchString={searchValue}
      />
      <MusicHomeSearchControlResetButton />
    </div>
  );
}
